<template>
  <div
    class="result-list"
    v-loading="loading"
    element-loading-text="加载中"
    element-loading-spinner="el-icon-loading"
  >
    <!-- <result-size :result_num="result_num" :curPage="curPage"></result-size> -->
    <!-- <sort-pattern :detailIcon="detailIcon" :listIcon="listIcon" :modelType="modelType"></sort-pattern> -->
    <div class="list">
      <el-table
        :header-cell-style="{ textAlign: 'center' }"
        :cell-style="{ textAlign: 'center' }"
        :data="resultList"
        stripe
        highlight-curPagerent-row
        :row-style="{ height: '40px' }"
      >
        <el-table-column type="index" label="序号" width="70px">
        </el-table-column>
        <el-table-column prop="name" label="书名" width="150px">
          <template slot-scope="scope">
            <span
              v-html="scope.row.name"
              data-warden-title="显示文章内容"
              :data-warden-info="scope.row.name"
              :data-warden-bookId="scope.row.id"
              @click="jumpBookDetail(scope.row.id)"
              class="book-name"
            ></span>
          </template>
        </el-table-column>
        <el-table-column prop="author" label="著者" width="180px">
          <template slot-scope="scope">
            <span v-html="scope.row.author"></span>
          </template>
        </el-table-column>
        <el-table-column prop="position" label="馆藏地" width="300px">
          <template slot-scope="scope">
            <span v-html="scope.row.position"></span>
          </template>
        </el-table-column>
        <el-table-column
          prop="popularity"
          label="热度"
          width="80px"
        ></el-table-column>
        <el-table-column label="操作" width="120px">
          <template slot-scope="scope">
            <!--点击收藏-->
            <img
              v-if="scope.row.star === 1"
              src="../assets/images/icons/star1.png"
              class="listIcon"
              @click="handleCilckCollect(scope.row)"
              title="取消收藏"
            />
            <img
              v-else-if="scope.row.star === 2"
              src="../assets/images/icons/star2.png"
              class="listIcon"
              @click="handleCilckCollect(scope.row)"
              title="收藏书籍"
            />
            <img
              src="../assets/images/icons/bookicon.png"
              data-warden-title="显示文章内容"
              :data-warden-info="scope.row.name"
              :data-warden-bookId="scope.row.id"
              class="listIcon"
              style="margin-left:9px"
              v-if="!scope.row.fullBook"
              @click="jumpBookDetail(scope.row.id)"
              title="试读"
            />
            <img
              src="../assets/images/icons/bookicon2.png"
              data-warden-title="显示文章内容"
              :data-warden-info="scope.row.name"
              :data-warden-bookId="scope.row.id"
              class="listIcon"
              style="margin-left:9px"
              v-else
              @click="jumpBookDetail(scope.row.id)"
              title="全书"
            />
          </template>
        </el-table-column>
      </el-table>
    </div>
    <my-dialog
      :title="'提示'"
      :icon="require('@/assets/images/userPage/user.png')"
      ref="messageDialog"
      class="message-dialog"
      @confirm="clearHistory"
    >
      确认取消该收藏？
    </my-dialog>
    <RetrieveDialogCollect
      v-if="openCollect"
      :openCollect="openCollect"
      :bookId="bookId"
      @closeCollect="closeCollect"
      @collectSuccess="collectSuccess"
    ></RetrieveDialogCollect>
  </div>
</template>

<script>
import PageBar from './PageBar.vue'
import ResultSize from './ResultSize.vue'
import SortPattern from './SortPattern .vue'
import RetrieveDialogCollect from './RetrieveDialogCollect.vue'
import MyDialog from './MyDialog.vue'
import { Message } from 'element-ui'
export default {
  components: {
    PageBar,
    ResultSize,
    SortPattern,
    RetrieveDialogCollect,
    MyDialog
  },
  name: 'SearchResult',
  props: {},
  data () {
    return {
      pageNum: 27,
      curPage: 1,
      detailIcon: require('../assets/images/icons/detail2.png'),
      listIcon: require('../assets/images/icons/list.png'),
      modelType: 2,
      openCollect: false,
      bookId: 0,
      resultList: [
        // {
        //   name: '暑病证治要略',
        //   author: '曹赤电',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 30,
        //   star: 2
        // },
        // {
        //   name: '卫生易筋经',
        //   author: '刘涓子、龚庆宣',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 25,
        //   star: 2
        // },
        // {
        //   name: '暑病证治要略',
        //   author: '曹赤电',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 30,
        //   star: 2
        // },
        // {
        //   name: '卫生易筋经',
        //   author: '刘涓子、龚庆宣',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 25,
        //   star: 2
        // },
        // {
        //   name: '暑病证治要略',
        //   author: '曹赤电',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 30,
        //   star: 2
        // },
        // {
        //   name: '卫生易筋经',
        //   author: '刘涓子、龚庆宣',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 25,
        //   star: 2
        // },
        // {
        //   name: '暑病证治要略',
        //   author: '曹赤电',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 30,
        //   star: 2
        // },
        // {
        //   name: '卫生易筋经',
        //   author: '刘涓子、龚庆宣',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 25,
        //   star: 2
        // },
        // {
        //   name: '暑病证治要略',
        //   author: '曹赤电',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 30,
        //   star: 2
        // },
        // {
        //   name: '卫生易筋经',
        //   author: '刘涓子、龚庆宣',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 25,
        //   star: 2
        // },
        // {
        //   name: '暑病证治要略',
        //   author: '曹赤电',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 30,
        //   star: 2
        // },
        // {
        //   name: '卫生易筋经',
        //   author: '刘涓子、龚庆宣',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 25,
        //   star: 2
        // },
        // {
        //   name: '暑病证治要略',
        //   author: '曹赤电',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 30,
        //   star: 2
        // },
        // {
        //   name: '卫生易筋经',
        //   author: '刘涓子、龚庆宣',
        //   position: '139-北京-中国中医科学院图书馆',
        //   heat: 25,
        //   star: 2
        // }
      ],
      loading: false
    }
  },
  mounted () {
    this.$bus.$on('updateSearchResult', data => {
      console.log(data)
      for (let i = 0; i < data.data1.length; i++) {
        data.data1[i].name = data.data1[i].bookName
        data.data1[i].author = data.data1[i].authorDetail
        data.data1[i].position = data.data1[i].library
        if (String(data.data2[i].isInStoreBook) === 'true') {
          data.data1[i].star = 1
        } else {
          data.data1[i].star = 2
        }
        data.data1[i].bookId = data.data1[i].id
        data.data1[i].fullBook = (data.data1[i].isCustom === 1 || data.data1[i].isFree === 1)
      }
      this.resultList = data.data1
      this.loading = false
    })
    this.$bus.$on('collectSuccess', data => {
      let id1 = this.resultList.findIndex(item => item.bookId === data)
      this.resultList[id1].star = 1
    })
  },
  beforeDestroy () {
    this.$bus.$off('updateSearchResult')
    this.$bus.$off('collectSuccess')
  },
  methods: {
    handleCurrentChange (val) {
      this.curPage = val
    },
    changeModel (type) {
      this.modelType = type
    },
    jumpBookDetail (bookId) {
      let pathInfo = '/bookDetail'
      if (this.$route.params.url) {
        pathInfo = '/' + this.$route.params.url + pathInfo
      }
      let routeUrl = this.$router.resolve({
        path: pathInfo,
        query: {
          book: bookId
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    closeCollect () {
      this.openCollect = false
    },
    handleCilckCollect (item) {
      if (String(localStorage.getItem('isLogined')) === 'true') {
        if (item.star === 2) {
          this.openCollect = true
          this.bookId = item.bookId
          console.log(this.$router)
        } else {
          this.$refs.messageDialog.open(() => {
            console.log(item)
            let userId = localStorage.getItem('userId')
            let url =
              'retrieve/storeBook/deleteBookInStore?userId=' +
              userId +
              '&bookId=' +
              item.bookId
            this.$http.delete(url).then(res => {
              // console.log('取消收藏成功')
              Message({
                type: 'success',
                message: '取消收藏成功!'
              })
              item.star = 2
            })
          })
        }
      } else {
        Message({
          type: 'error',
          message: '用户需要登录才能完成操作!'
        })
      }
    },
    clearHistory () {
      this.$refs.messageDialog.close()
    }
  }
}
</script>

<style scoped>
.result-list {
  width: 890px;
  height: 660px;
  /* margin-left: 18px; */
  background: #ffffff;
}

.page-bar {
  display: flex;
  justify-content: center;
  align-items: center;
}

.list {
  width: 910px;
  height: 660px;
  margin: auto;
  overflow-y: auto;
  font-size: 14px;
}

.list >>> .el-table__header .el-table__cell {
  color: #634c37;
  /* text-align: center; */
}

.list >>> .el-table__body {
  color: #634c37;
  /* margin-left: 25px; */
}

.list >>> .el-table__row--striped {
  background-color: #f8f0e8;
}

.listIcon {
  width: 29px;
  height: 25px;
  cursor: pointer;
}
.listIcon:hover {
  opacity: 0.7;
}

.detailText {
  color: #634c37;
}

.listText {
  color: #9e5c1d;
}
/* 滚动条 */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  border-radius: 3px;
  background: rgba(0, 0, 0, 0.06);
}
/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: rgba(158, 92, 29, 0.2);
}

.result-list >>> .el-loading-spinner i {
  color: #9e5c1d;
  font-size: 30px;
}

.result-list >>> .el-loading-spinner p {
  color: #634c37;
  font-size: 18px;
}
.message-dialog >>> .el-dialog {
  width: 380px;
  height: 265px;
}

.message-dialog >>> .el-dialog__body {
  height: 130px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #634c37;
}

.book-name {
  cursor: pointer;
}

.book-name:hover {
  color: #9e5c1d;
}
</style>



// WEBPACK FOOTER //
// src/components/SearchResultList.vue